import React from "react"
import {useQuery} from "@apollo/client"

import {Link} from "react-router-dom"
import {GetAvatarUrl} from "../../utils/getAvatarUrl"
import {GET_LOG_LIST} from "./graphql/query"
import LogRow from "./LogRow"
import SpinLoader from "../../components/loaders/SpinLoader"
import useInfiniteScroll from "../../utils/InfiniteScroll"
import {useEffect} from "react"
import {useInit} from "../../providers/Init"

export default function LogsScreen() {
  const {settings} = useInit()
  // filter state
  const [search, setSearch] = React.useState()
  const [action, setAction] = React.useState()

  const [loading2, setLoading2] = React.useState(false)
  const [list, setList] = React.useState([])
  const [pageInfo, setPageInfo] = React.useState()
  const {loading, fetchMore, refetch} = useQuery(GET_LOG_LIST, {
    fetchPolicy: "network-only",
    variables: {},
    onCompleted: (data) => {
      setList(data.LogList.edges.map((edge) => edge.node))

      setPageInfo(data.LogList.pageInfo)
    },
  })
  const onMore = async () => {
    if (pageInfo.hasNextPage) {
      setLoading2(true)
      const moreresult = await fetchMore({
        variables: {
          ...(search && {search: search}),
          ...(action && {action: action}),
          skip: pageInfo.endCursor,
        },
      })
      setList(list.concat(moreresult.data.LogList.edges.map((edge) => edge.node)))
      setPageInfo(moreresult.data.LogList.pageInfo)
      setLoading2(false)
    }
  }
  const [lastElementRef] = useInfiniteScroll(pageInfo?.hasNextPage ? () => onMore() : () => {}, loading)

  const clearFilter = () => {
    setSearch("")
    setAction("")
  }

  const refetchMore = () => {
    refetch({
      search: search,
      action: action,
    })
  }

  useEffect(() => {
    refetchMore()

    return () => {}
  }, [search, action])

  return (
    <div className="page-wrapper">
      <div className="gh-canvas-header">
        <div className="gh-canvas-header-content">
          <div className="flex flex-column">
            <h2 className="gh-canvas-title">
              <a href="#_" className="active ">
                Лог
              </a>
            </h2>
          </div>
          <div className="view-actions"></div>
        </div>
      </div>

      <div className="filter-box">
        <div className="row row-cols-lg-auto g-2 align-items-center mb-2">
          <div className="col-12">
            <input type="search" value={search} onChange={(e) => setSearch(e.target.value)} className="form-control form-control-sm" placeholder="Хайх" />
          </div>

          <div className="col-12">
            <select value={action} className="form-select" onChange={(e) => setAction(e.target.value)}>
              <option value={""}>-</option>
              {settings.user_actions.map((a, k) => (
                <option key={k} value={a}>
                  {a}
                </option>
              ))}
            </select>
          </div>

          {(search || action) && (
            <>
              <div className="col-12">
                <button className="btn btn-secondary" onClick={clearFilter}>
                  Арилгах
                </button>
              </div>
            </>
          )}
        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="row">
              <div className="col"></div>
            </div>
          </div>
        </div>

        {pageInfo && (
          <div className="records">
            Үр дүн: <b>{list.length}</b>/<b>{pageInfo.count}</b>
          </div>
        )}
      </div>

      <div className="">
        <div className="table-responsive">
          <table className="table no-wrap user-table mb-0">
            <thead>
              <tr>
                <th scope="col" className="border-0 text-uppercase font-medium ps-2 pe-2">
                  Огноо
                </th>
                <th scope="col" className="border-0 text-uppercase font-medium">
                  Үйлдэл
                </th>
                <th scope="col" className="border-0 text-uppercase font-medium">
                  Тайлбар
                </th>
                <th scope="col" className="border-0 text-uppercase font-medium">
                  Хэрэглэгч
                </th>
                <th scope="col" className="border-0 text-uppercase font-medium">
                  Төрөл
                </th>
                <th scope="col" className="border-0 text-uppercase font-medium">
                  IP хаяг
                </th>
              </tr>
            </thead>
            <tbody>
              {list.map((log, key) => {
                return <LogRow log={log} key={key} />
              })}
            </tbody>
          </table>
        </div>
        {(loading || loading2) && (
          <div className="loader-wrap">
            <SpinLoader loading={true} />
          </div>
        )}
        {pageInfo?.hasNextPage && (
          <>
            <div className="lastDiv" ref={lastElementRef}></div>
          </>
        )}
      </div>
    </div>
  )
}
